export default {
  AVAILABLE_BALANCE: 'Available Balance',
  TOTAL_SALES: 'Total Sales',
  LAST_PAID: 'Last Paid',
  AIRTIME: 'Airtime',
  DATA: 'Data',
  ELECTRICITY: 'Electricity',
  HOLLYWOOD_BETS: 'Hollywood Bets',
  UNIPIN: 'Unipin',
  OTHERELECTRICITY: 'Other Electricity',
  DSTV: 'DSTV',
  LOTTO: 'Lotto',
  M2M: 'M2M',
  // EVENT_TICKETS: 'Event Tickets',
  // LongHaulBus: 'Long Haul Bus Tickets',
  // PutcoTicket: 'Putco Tickets' },
  RICA_TOTAL: 'Rica - total',
  RICA_SUCCESS: 'Rica - success',
  RICA_FAILED: 'Rica - fail',
  OTHER: 'Other',
  ENTERTAINMENT: 'Entertainment',
  'BILL PAYMENTS': 'Bill Payments',
  TICKETING: 'Ticketing',
  VODACOMAIRTIME: 'Vodacom Airtime',
  MTNAIRTIME: 'MTN Airtime',
  CELLCAIRTIME: 'Cell C Airtime',
  TELKOMAIRTIME: 'Telkom Airtime',
  RINGAS: 'Ringas Airtime',
  C4C: 'C4C Airtime',
  VODACOMDATA: 'Vodacom Data',
  MTNDATA: 'MTN Data',
  CELLCDATA: 'Cell C Data',
  TELKOMDATA: 'Telkom Data',
  HOLLOYWOODBETS: 'Holloywood Bets',
  LOTTOSTAR: 'Lotto Star',
  BLUVOUCHER: 'Blu Voucher',
  MUKURU: 'Mukuru',
  ECOCASH: 'Eco Cash',
  MAMAMONEY: 'Mama Money',
  HELLOPAISA: 'Hello Paisa',
  'PAY@': 'Pay@',
  EASYPAY: 'Easypay',
  BLUBILL: 'Blu Bill',
  TICKETPRO: 'Ticketpro',
  BUSTICKETS: 'Bus Tickets',
  OTHERAIRTIME: 'Other Airtime',
  OTHERDATA: 'Other Data',
  OTHERENTERTAINMENT: 'Other Entertainment',
  BILLING: 'Billing',
  OTHERBILLPAYMENTS: 'Other Billing',
  CATEGORYNOTFOUND: 'Category Not Found',
  OTHERTICKETING: 'Other Ticketing',
  RICA: 'RICA',
};
